import { IFoundationProgram, IProgramClass, IProgramWorkSheet, IWorkSheet } from "../models/foundationProgram";
import { IProgramSubject, Subjects } from "./subjects";


export const WorkSheets = {
    CPS: { workSheetId: 1, workSheetName: 'Practice Sheet Sol' } as IWorkSheet,
    WT: { workSheetId: 2, workSheetName: 'W.T' } as IWorkSheet,
    FT: { workSheetId: 3, workSheetName: 'F.T' } as IWorkSheet,
    MT: { workSheetId: 4, workSheetName: 'M.T' } as IWorkSheet,
    MEO: { workSheetId: 5, workSheetName: 'M.E.O' } as IWorkSheet,
    GO: { workSheetId: 6, workSheetName: 'B.V.V.S G.O' } as IWorkSheet,
    Solutions: { workSheetId: 7, workSheetName: 'Chapter Sol' } as IWorkSheet,
    SchedulesNcirculars: { workSheetId: 8, workSheetName: 'Schedules & circulars' } as IWorkSheet,
    StateWideRanks: { workSheetId: 9, workSheetName: 'State Wide Ranks' } as IWorkSheet,
    SpecialPapers: { workSheetId: 10, workSheetName: 'Special Papers' } as IWorkSheet,
    CT: { workSheetId: 11, workSheetName: 'C.T' } as IWorkSheet,
    MO: { workSheetId: 12, workSheetName: 'M.O' } as IWorkSheet,
    OUT: { workSheetId: 13, workSheetName: 'O.U.T' } as IWorkSheet,
    SO: { workSheetId: 14, workSheetName: 'S.O' } as IWorkSheet
}


export const EdgeProgramWorkSheets = [
    {
        ...WorkSheets.SchedulesNcirculars
    },
    {
        ...WorkSheets.Solutions,
        subjects: [
            Subjects.Maths,
            Subjects.Physics,
            Subjects.Chemistry,
            Subjects.Reasoning

        ] as IProgramSubject[]
    },
    {
        ...WorkSheets.CPS,
        subjects: [
            Subjects.Maths,
            Subjects.Physics,
            Subjects.Chemistry
        ] as IProgramSubject[]
    },
    {
        ...WorkSheets.WT,
    },
    {
        ...WorkSheets.FT,
    },
    {
        ...WorkSheets.MT,
    },
    {
        ...WorkSheets.SO
    },
    {
        ...WorkSheets.MO,
    },
    {
        ...WorkSheets.GO
    },

    {
        ...WorkSheets.StateWideRanks
    },
    {
        ...WorkSheets.SpecialPapers
    }

] as IProgramWorkSheet[];

export const TechnoOlympiadWorkSheets = [
    {
        ...WorkSheets.SchedulesNcirculars
    },
    {
        ...WorkSheets.Solutions,
        subjects: [
            Subjects.Maths,
            Subjects.Physics,
            Subjects.Chemistry,
            Subjects.Reasoning
        ] as IProgramSubject[]
    },
    {
        ...WorkSheets.CPS,
        subjects: [
            Subjects.Maths,
            Subjects.Physics,
            Subjects.Chemistry

        ] as IProgramSubject[]
    },

    {
        ...WorkSheets.FT,
    },
    {
        ...WorkSheets.CT,
    },
    {
        ...WorkSheets.SO
    },
    {
        ...WorkSheets.MO,
    },

    {
        ...WorkSheets.GO
    },


    {
        ...WorkSheets.StateWideRanks
    },
    {
        ...WorkSheets.SpecialPapers
    }

] as IProgramWorkSheet[];

export const GlobalOlympiadWorkSheets = [
    {
        ...WorkSheets.SchedulesNcirculars
    },
    {
        ...WorkSheets.Solutions,
        subjects: [
            Subjects.Maths,
            Subjects.Science,
            Subjects.Reasoning,
            Subjects.English
        ] as IProgramSubject[]
    },
    {
        ...WorkSheets.CPS,
        subjects: [
            Subjects.Maths,
            Subjects.Science,
            Subjects.Reasoning
        ] as IProgramSubject[]
    },

    {
        ...WorkSheets.FT,
    },
    {
        ...WorkSheets.CT,
    },
    {
        ...WorkSheets.SO
    },
    {
        ...WorkSheets.MO,
    },

    {
        ...WorkSheets.GO
    },


    {
        ...WorkSheets.StateWideRanks
    },
    {
        ...WorkSheets.SpecialPapers
    }

] as IProgramWorkSheet[];

export const MediEdgeProgramWorkSheets = [
    {
        ...WorkSheets.SchedulesNcirculars
    },
    {
        ...WorkSheets.Solutions,
        subjects: [
            Subjects.Biology
        ] as IProgramSubject[]
    },
    {
        ...WorkSheets.CPS,
        subjects: [
            Subjects.Biology,

        ] as IProgramSubject[]
    },
    {
        ...WorkSheets.MT,
    },
    {
        ...WorkSheets.SO
    },
    {
        ...WorkSheets.MO,
    },

    {
        ...WorkSheets.GO
    },


    {
        ...WorkSheets.StateWideRanks
    },
    {
        ...WorkSheets.SpecialPapers
    }

] as IProgramWorkSheet[];

export const FACTProgramWorkSheets = [
    {
        ...WorkSheets.SchedulesNcirculars
    },
    {
        ...WorkSheets.Solutions,
        subjects: [
            Subjects.Maths,
            Subjects.PhysicalScience,
            Subjects.Reasoning
        ] as IProgramSubject[]
    },
    {
        ...WorkSheets.CPS,
        subjects: [
            Subjects.Maths,
            Subjects.PhysicalScience
        ] as IProgramSubject[]
    },

    {
        ...WorkSheets.OUT,
    },
    {
        ...WorkSheets.SO
    },
    {
        ...WorkSheets.MO,
    },

    {
        ...WorkSheets.GO
    },


    {
        ...WorkSheets.StateWideRanks
    },
    {
        ...WorkSheets.SpecialPapers
    }

] as IProgramWorkSheet[];

export const ASKJrProgramWorkSheets = [
    {
        ...WorkSheets.SchedulesNcirculars
    },
    {
        ...WorkSheets.Solutions,
        subjects: [
            Subjects.Maths,
            Subjects.Science,
        ] as IProgramSubject[]
    },
    {
        ...WorkSheets.CPS,
        subjects: [
            Subjects.Maths,
            Subjects.Science
        ] as IProgramSubject[]
    },

    {
        ...WorkSheets.SO,
    },

    {
        ...WorkSheets.MO,
    },


    {
        ...WorkSheets.StateWideRanks
    },
    {
        ...WorkSheets.SpecialPapers
    }

] as IProgramWorkSheet[];

export const ASKSrProgramWorkSheets = [
    {
        ...WorkSheets.SchedulesNcirculars
    },
    {
        ...WorkSheets.Solutions,
        subjects: [
            Subjects.Maths,
            Subjects.PhysicalScience,
        ] as IProgramSubject[]
    },
    {
        ...WorkSheets.CPS,
        subjects: [
            Subjects.Maths,
            Subjects.PhysicalScience
        ] as IProgramSubject[]
    },

    {
        ...WorkSheets.SO,
    },

    {
        ...WorkSheets.MO,
    },


    {
        ...WorkSheets.StateWideRanks
    },
    {
        ...WorkSheets.SpecialPapers
    }

] as IProgramWorkSheet[];


export const FoundationProgramConstants = [
    {
        programId: 1,
        programName: 'Edge',
        classList: [
            {
                classId: 6,
                className: '6th Class',
                workSheets: EdgeProgramWorkSheets
            },
            {
                classId: 7,
                className: '7th Class',
                workSheets: EdgeProgramWorkSheets
            },
            {
                classId: 8,
                className: '8th Class',
                workSheets: EdgeProgramWorkSheets
            },
            {
                classId: 9,
                className: '9th Class',
                workSheets: EdgeProgramWorkSheets
            },
            {
                classId: 10,
                className: '10th Class',
                workSheets: EdgeProgramWorkSheets
            }
        ] as IProgramClass[]
    },
    {
        programId: 2,
        programName: 'Techno Olympiad',
        classList: [
            {
                classId: 6,
                className: '6th Class',
                workSheets: TechnoOlympiadWorkSheets
            },
            {
                classId: 7,
                className: '7th Class',
                workSheets: TechnoOlympiadWorkSheets
            },
            {
                classId: 8,
                className: '8th Class',
                workSheets: TechnoOlympiadWorkSheets
            },
            {
                classId: 9,
                className: '9th Class',
                workSheets: TechnoOlympiadWorkSheets
            },
            {
                classId: 10,
                className: '10th Class',
                workSheets: TechnoOlympiadWorkSheets
            }
        ] as IProgramClass[]
    },
    {
        programId: 3,
        programName: 'Global Olympiad',
        classList: [
            {
                classId: 1,
                className: '1st Class',
                workSheets: GlobalOlympiadWorkSheets
            },
            {
                classId: 2,
                className: '2nd Class',
                workSheets: GlobalOlympiadWorkSheets
            },
            {
                classId: 3,
                className: '3rd Class',
                workSheets: GlobalOlympiadWorkSheets
            },
            {
                classId: 4,
                className: '4th Class',
                workSheets: GlobalOlympiadWorkSheets
            },
            {
                classId: 5,
                className: '5th Class',
                workSheets: GlobalOlympiadWorkSheets
            }
        ] as IProgramClass[]
    },
    {
        programId: 4,
        programName: 'Medi Edge',
        classList: [
            {
                classId: 6,
                className: '6th Class',
                workSheets: MediEdgeProgramWorkSheets
            },
            {
                classId: 7,
                className: '7th Class',
                workSheets: MediEdgeProgramWorkSheets
            },
            {
                classId: 8,
                className: '8th Class',
                workSheets: MediEdgeProgramWorkSheets
            },
            {
                classId: 9,
                className: '9th Class',
                workSheets: MediEdgeProgramWorkSheets
            },
            {
                classId: 10,
                className: '10th Class',
                workSheets: MediEdgeProgramWorkSheets
            }
        ] as IProgramClass[]
    },
    {
        programId: 5,
        programName: 'FACT Olympiad',
        classList: [
            {
                classId: 6,
                className: '6th Class',
                workSheets: FACTProgramWorkSheets
            },
            {
                classId: 7,
                className: '7th Class',
                workSheets: FACTProgramWorkSheets
            },
            {
                classId: 8,
                className: '8th Class',
                workSheets: FACTProgramWorkSheets
            },
            {
                classId: 9,
                className: '9th Class',
                workSheets: FACTProgramWorkSheets
            }
        ] as IProgramClass[]
    }
    ,
    {
        programId: 6,
        programName: 'Ask Jr',
        classList: [
            {
                classId: 1,
                className: '1st Class',
                workSheets: ASKJrProgramWorkSheets
            },
            {
                classId: 2,
                className: '2nd Class',
                workSheets: ASKJrProgramWorkSheets
            },
            {
                classId: 3,
                className: '3rd Class',
                workSheets: ASKJrProgramWorkSheets
            },
            {
                classId: 4,
                className: '4th Class',
                workSheets: ASKJrProgramWorkSheets
            },
            {
                classId: 5,
                className: '5th Class',
                workSheets: ASKJrProgramWorkSheets
            }
        ] as IProgramClass[]
    },
    {
        programId: 7,
        programName: 'Ask Sr',
        classList: [
            {
                classId: 6,
                className: '6th Class',
                workSheets: ASKSrProgramWorkSheets
            },
            {
                classId: 7,
                className: '7th Class',
                workSheets: ASKSrProgramWorkSheets
            },
            {
                classId: 8,
                className: '8th Class',
                workSheets: ASKSrProgramWorkSheets
            },
            {
                classId: 9,
                className: '9th Class',
                workSheets: ASKSrProgramWorkSheets
            }
        ] as IProgramClass[]
    }
] as IFoundationProgram[];

export const FoundationProgramData = {
    EdgeProgram: FoundationProgramConstants[0],
    TechnoOlympiadProgram: FoundationProgramConstants[1],
    GlobalOlympiadProgram: FoundationProgramConstants[2],
    MediEdgeProgram: FoundationProgramConstants[3],
    FACTProgram: FoundationProgramConstants[4],
    ASKJrProgram: FoundationProgramConstants[5],
    ASKSrProgram: FoundationProgramConstants[6]
}